(function () {
  function initReveal(root) {
    var items = root.querySelectorAll('.aff-reveal');
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { obs.observe(el); });
  }

  function initForm(root) {
    var form = root.querySelector('[data-aff-form], .aff-contact-form');
    if (!form) return;
    var success = root.querySelector('[data-aff-form-success]');
    if (success && success.classList.contains('is-visible')) {
      var apply = root.querySelector('#apply');
      if (apply) apply.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.textContent = 'Submitting…';
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-oxiram-affiliate]').forEach(function (root) {
      initReveal(root);
      initForm(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
